import { HttpService } from 'src/api/common/HttpService';
import { UrlService } from 'src/api/common/UrlService';
import { ApiStatus } from 'src/constants/ApiStatus';
import { CteApiUrl } from 'src/constants/BaseUrls';

type ActionType = {
  id: number | string;
};

export const ActionService = () => {
  const { HttpGet, HttpPost, HttpDelete } = HttpService();

  const GetAll = async (body: any) => {
    const suffix =
      typeof body === 'string' ? body : UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/action${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetById = async (body: ActionType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/action/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const CreateOrUpdate = async (body: any) => {
    const url = `${CteApiUrl}/api/v1/action/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

  const LogicDeleteById = async (body: ActionType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/action/detail${suffix}`;
    const response = await HttpDelete(url);
    return response;
  };

  return {
    GetAll,
    GetById,
    CreateOrUpdate,
    LogicDeleteById,
  };
};
